<template>
	<div>
		<h1>Assessment of the Risk of Bias</h1>

		

		<InputSelectMultiWithoutOthers
			question="Which authors assessed the risk of bias?"
			v-model="$tera.project.assessedRobAuthors"
			:options="this.asRobAuthors"
			questionMark="Rob-2"
		/>

		<InputTextNumber
			question="The number of authors reviewed the risk of bias was"
			v-model="numberOfRiskOfBiasAuthors"
			questionMark="Rob-1"
			:disabled="disabled"
		/>

		<InputSelectYesNo
			question="Did each author independently review the risk of bias?"
			v-model="$tera.project.isIndependent"
			questionMark="Rob-3"
		/>

		<InputSelectMulti
			question="Risk of bias was determined using the:"
			:options="options.tools"
			v-model="$tera.project.riskOfBiasToolUsed"
			questionMark="Rob-4"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputAssesmentOfTheRiskOfBias from "./OutputAssessmentOfTheRiskOfBias";
import BasePreviewOutput from "@/components/BasePreviewOutput.vue";
import InputSelectYesNo from "@/components/InputSelectYesNo.vue";
import InputSelectMulti from "@/components/InputSelectMulti.vue";
import InputSelectMultiWithoutOthers from "@/components/InputSelectMultiWithoutOther.vue";

export default {
	name: "ViewMethodAssessmentOfTheRiskOfBias",

	components: {
		InputSelectYesNo,
		InputSelectMulti,
		InputSelectMultiWithoutOthers,
		BasePreviewOutput
	},
	computed: {
		asRobAuthors() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.planTable?.rows.forEach(el => {
				if (el.tasks == "Risk of Bias assessment" && el.peopleInvolved != "") {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		},
		numberOfRiskOfBiasAuthors() {
			return this.$tera.project.assessedRobAuthors?.length;
		}
	},
	methods: {
		checkUnion(U) {
			for (var i = 0; i < U.length; i++) {
				for (var j = i + 1; j < U.length; j++) {
					if (U[i].label == U[j].label) {
						U.splice(j, 1);
						j--;
					}
				}
			}
		}
	},
	data() {
		return {
			numberOptions: ["1", "2", "3", "4", "5", "6"],
			//asRobAuthors: [], //--assessed the RoB
			outputComponent: OutputAssesmentOfTheRiskOfBias,
			options: {
				tools: [
					{ label: "Cochrane Risk of Bias tool" },
					{ label: "Cochrane Risk of Bias 2 tool" },
					{ label: "Jadad Scale" },
					{ label: "Newcastle-Ottawa Scale" },
					{ label: "MASTER scale" },
					{ label: "QUADAS-1" },
					{ label: "QUADAS-2" },
					{ label: "ROBINS-I" },
					{ label: "ROBINS-II" },
					{ label: "AMSTAR 1" },
					{ label: "AMSTAR 2" }
				]
			},
			disabled:true
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
